import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// api
import baseApi from "../../api/baseApi";

// diğer importlar
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
  isLoading: false,
  autoClose: 5000,
  transition: Slide,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const initialState = {
  company: {},
  companyLoading: true,
  companyRefresh: true,

  companies: [],
  companiesLoading: true,
  companiesRefresh: true,

  companyEarnings: {},
  companyEarningsLoading: true,
  companyEarningsRefresh: true,

  primSummary: {},
  primSummaryLoading: true,
  primSummaryRefresh: true,

  couponSummary: {},
  couponSummaryLoading: true,
  couponSummaryRefresh: true,

  serviceCommissionSummary: {},
  serviceCommissionSummaryLoading: true,
  serviceCommissionSummaryRefresh: true,

  publicCompanies: [],
  publicCompaniesLoading: true,

  createCompanyLoading: false,
  updateCompanyLoading: false,
  deleteCompanyLoading: false,

  applyCouponLoading: false,
  uploadLogoLoading: false,
};

export const fetchCompany = createAsyncThunk(
  "company/fetchCompany",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Companies/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCompanies = createAsyncThunk(
  "company/fetchCompanies",
  async () => {
    try {
      const response = await baseApi.get(`/Companies`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPublicCompanies = createAsyncThunk(
  "auth/fetchPublicCompanies",
  async () => {
    try {
      const response = await baseApi.get(`/Companies/GetPublicCompanies`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      throw new Error(errMsg);
    }
  }
);

export const fetchCompanyEarnings = createAsyncThunk(
  "company/fetchCompanyEarnings",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Companies/GetCompanyEarnings/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPrimSummary = createAsyncThunk(
  "company/fetchPrimSummary",
  async (id) => {
    if (id) {
      try {
        const response = await baseApi.get(
          `/Companies/GetPrimSummary?companyId=${id}`
        );

        return response.data.result;
      } catch (error) {
        const errMsg =
          error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

        toast.error(errMsg, {
          ...toastConfig,
        });

        throw new Error(errMsg);
      }
    } else {
      try {
        const response = await baseApi.get(`/Companies/GetPrimSummary`);

        return response.data.result;
      } catch (error) {
        const errMsg =
          error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

        toast.error(errMsg, {
          ...toastConfig,
        });

        throw new Error(errMsg);
      }
    }
  }
);

export const fetchCouponSummary = createAsyncThunk(
  "company/fetchCouponSummary",
  async (id) => {
    if (id) {
      try {
        const response = await baseApi.get(
          `/Companies/GetCouponSummary?companyId=${id}`
        );

        return response.data.result;
      } catch (error) {
        const errMsg =
          error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

        toast.error(errMsg, {
          ...toastConfig,
        });

        throw new Error(errMsg);
      }
    } else {
      try {
        const response = await baseApi.get(`/Companies/GetCouponSummary`);

        return response.data.result;
      } catch (error) {
        const errMsg =
          error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

        toast.error(errMsg, {
          ...toastConfig,
        });

        throw new Error(errMsg);
      }
    }
  }
);

export const fetchServiceCommissionSummary = createAsyncThunk(
  "company/fetchServiceCommissionSummary",
  async (id) => {
    if (id) {
      try {
        const response = await baseApi.get(
          `/Companies/GetServiceCommissionSummary?companyId=${id}`
        );

        return response.data.result;
      } catch (error) {
        const errMsg =
          error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

        toast.error(errMsg, {
          ...toastConfig,
        });

        throw new Error(errMsg);
      }
    } else {
      try {
        const response = await baseApi.get(
          `/Companies/GetServiceCommissionSummary`
        );

        return response.data.result;
      } catch (error) {
        const errMsg =
          error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

        toast.error(errMsg, {
          ...toastConfig,
        });

        throw new Error(errMsg);
      }
    }
  }
);

export const applyCoupon = createAsyncThunk(
  "company/applyCoupon",
  async (values) => {
    if (!values || !values.couponCode || !values.usedCompanyId) {
      const errMsg = "Kupon kodu veya firma bilgisi eksik!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("İşlem yapılıyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Companies/UseCoupon`, values);

      toast.update(loadingToast, {
        render: "Kupon başarıyla kullanıldı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const createCompany = createAsyncThunk(
  "company/createCompany",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      companyName: values.companyName,
      companyTableName: values.companyTableName,
      authName: values.authName,
      authSurname: values.authSurname,
      companyType: parseInt(values.companyType),
      taxOffice: values.taxOffice,
      taxNumber: values.taxNumber,
      city: values.city,
      state: values.state,
      address: values.address,
      phoneNumber: values.phoneNumber,
      email: values.email,
      primAmount: parseFloat(values.primAmount),
      commissionFee: parseFloat(values.commissionFee),
      primTriggerPercent: parseFloat(values.primTriggerPercent),
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Companies`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      id: values.id,
      companyName: values.companyName,
      companyTableName: values.companyTableName,
      authName: values.authName,
      authSurname: values.authSurname,
      companyType: parseInt(values.companyType),
      taxOffice: values.taxOffice,
      taxNumber: values.taxNumber,
      city: values.city,
      state: values.state,
      address: values.address,
      phoneNumber: values.phoneNumber,
      email: values.email,
      primAmount: parseFloat(values.primAmount),
      commissionFee: parseFloat(values.commissionFee),
      primTriggerPercent: parseFloat(values.primTriggerPercent),
      isActive: values.isActive,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/Companies/${values.id}`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Siliniyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.delete(`/Companies/${id}`);

      toast.update(loadingToast, {
        render: "Silindi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const uploadCompanyLogo = createAsyncThunk(
  "company/uploadCompanyLogo",
  async (values) => {
    if (!values || !values.companyId || !values.logo) {
      const errMsg = "Firma ID veya logo dosyası seçilmedi!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const formData = new FormData();
    formData.append("companyId", values.companyId);
    formData.append("logo", values.logo);

    const loadingToast = toast.loading("Logo yükleniyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Companies/UploadCompanyLogo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.update(loadingToast, {
        render: "Logo başarıyla yüklendi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage ||
        "Logo yüklenirken bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const companySlice = createSlice({
  name: "company",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompany.pending, (state, action) => {
        state.companyLoading = true;
        state.company = {};
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        state.company = action.payload;
        state.companyLoading = false;
      })
      .addCase(fetchCompany.rejected, (state, action) => {
        state.company = {};
        state.companyLoading = false;
      });

    builder
      .addCase(fetchCompanies.pending, (state, action) => {
        state.companiesLoading = true;
        state.companies = [];
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.companies = action.payload;
        state.companiesLoading = false;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.companies = [];
        state.companiesLoading = false;
      });

    builder
      .addCase(fetchPublicCompanies.pending, (state, action) => {
        state.publicCompaniesLoading = true;
        state.publicCompanies = [];
      })
      .addCase(fetchPublicCompanies.fulfilled, (state, action) => {
        state.publicCompanies = action.payload;
        state.publicCompaniesLoading = false;
      })
      .addCase(fetchPublicCompanies.rejected, (state, action) => {
        state.publicCompanies = [];
        state.publicCompaniesLoading = false;
      });

    builder
      .addCase(fetchCompanyEarnings.pending, (state, action) => {
        state.companyEarningsLoading = true;
        state.companyEarnings = {};
      })
      .addCase(fetchCompanyEarnings.fulfilled, (state, action) => {
        state.companyEarnings = action.payload;
        state.companyEarningsLoading = false;
      })
      .addCase(fetchCompanyEarnings.rejected, (state, action) => {
        state.companyEarnings = {};
        state.companyEarningsLoading = false;
      });

    builder
      .addCase(fetchPrimSummary.pending, (state, action) => {
        state.primSummaryLoading = true;
        state.primSummary = {};
      })
      .addCase(fetchPrimSummary.fulfilled, (state, action) => {
        state.primSummary = action.payload;
        state.primSummaryLoading = false;
      })
      .addCase(fetchPrimSummary.rejected, (state, action) => {
        state.primSummary = {};
        state.primSummaryLoading = false;
      });

    builder
      .addCase(fetchCouponSummary.pending, (state, action) => {
        state.couponSummaryLoading = true;
        state.couponSummary = {};
      })
      .addCase(fetchCouponSummary.fulfilled, (state, action) => {
        state.couponSummary = action.payload;
        state.couponSummaryLoading = false;
      })
      .addCase(fetchCouponSummary.rejected, (state, action) => {
        state.couponSummary = {};
        state.couponSummaryLoading = false;
      });

    builder
      .addCase(fetchServiceCommissionSummary.pending, (state, action) => {
        state.serviceCommissionSummaryLoading = true;
        state.serviceCommissionSummary = {};
      })
      .addCase(fetchServiceCommissionSummary.fulfilled, (state, action) => {
        state.serviceCommissionSummary = action.payload;
        state.serviceCommissionSummaryLoading = false;
      })
      .addCase(fetchServiceCommissionSummary.rejected, (state, action) => {
        state.serviceCommissionSummary = {};
        state.serviceCommissionSummaryLoading = false;
      });

    builder
      .addCase(createCompany.pending, (state, action) => {
        state.createCompanyLoading = true;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.createCompanyLoading = false;
        state.companiesRefresh = !state.companiesRefresh;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.createCompanyLoading = false;
      });

    builder
      .addCase(updateCompany.pending, (state, action) => {
        state.updateCompanyLoading = true;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.updateCompanyLoading = false;
        state.companyRefresh = !state.companyRefresh;
        state.companiesRefresh = !state.companiesRefresh;
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.updateCompanyLoading = false;
      });

    builder
      .addCase(deleteCompany.pending, (state, action) => {
        state.deleteCompanyLoading = true;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.deleteCompanyLoading = false;
        state.companiesRefresh = !state.companiesRefresh;
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.deleteCompanyLoading = false;
      });

    builder
      .addCase(applyCoupon.pending, (state, action) => {
        state.applyCouponLoading = true;
      })
      .addCase(applyCoupon.fulfilled, (state, action) => {
        state.applyCouponLoading = false;
        state.couponSummaryRefresh = !state.couponSummaryRefresh;
      })
      .addCase(applyCoupon.rejected, (state, action) => {
        state.applyCouponLoading = false;
      });

    builder
      .addCase(uploadCompanyLogo.pending, (state, action) => {
        state.uploadLogoLoading = true;
      })
      .addCase(uploadCompanyLogo.fulfilled, (state, action) => {
        state.uploadLogoLoading = false;
        state.companyRefresh = !state.companyRefresh;
        state.companiesRefresh = !state.companiesRefresh;
      })
      .addCase(uploadCompanyLogo.rejected, (state, action) => {
        state.uploadLogoLoading = false;
      });
  },
});

export default companySlice.reducer;
